import { render, staticRenderFns } from "./colegios.vue?vue&type=template&id=31cc48f3&scoped=true"
import script from "./colegios.vue?vue&type=script&lang=js"
export * from "./colegios.vue?vue&type=script&lang=js"
import style0 from "./colegios.vue?vue&type=style&index=0&id=31cc48f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc48f3",
  null
  
)

export default component.exports